// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2188":"Body-Body","2262":"reactPlayerHls","2723":"reactPlayerMux"}[chunkId] || chunkId) + "." + {"814":"b9e6381bd982c8d40d63","2188":"eba58e5d8a40f4e147e0","2262":"e114989b2e3d8e388825","2723":"a8759257525502e5ba5f"}[chunkId] + ".bundle.js";
};